import { WITHDRAW_ACTION, WITHDRAW_ACTION_SUCCESS, WITHDRAW_ACTION_FAILURE } from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
};

const withdrawActionReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case WITHDRAW_ACTION:
      return { ...state, loading: true };
    case WITHDRAW_ACTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case WITHDRAW_ACTION_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default withdrawActionReducer;
